import React from 'react';
import {BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';
import LoginPage from './pages/Auth/LoginPage';
import RegistrationPage from './pages/Auth/RegistrationPage';
import ForgotPasswordPage from './pages/Auth/ForgotPasswordPage';
import ResetPasswordPage from './pages/Auth/ResetPasswordPage';
import PrivacyPolicyPage from './pages/PrivacyPolicy/PrivacyPolicyPage';
import AccountDeletionPage from './pages/AccountDeletion/AccountDeletionPage';
import SecurityPolicyPage from './pages/SecurityPolicy/SecurityPolicyPage';
import ProtectedRoute from './components/Layout/ProtectedRoute';
import HomePage from './pages/Home/HomePage';
import SpasPage from './pages/Spas/SpasPage';
import SpaDetailsPage from './pages/SpaDetails/SpaDetailsPage';
import SpaControlPage from './pages/SpaControl/SpaControlPage';
import ContactUs from './pages/SpaControl/ContactUs/ContactUs';
import Filtration from './pages/SpaControl/Filtration/Filtration';
import SpaBoy from './pages/SpaControl/SpaBoy/SpaBoy';
import Troubleshoot from './pages/SpaControl/Troubleshoot/Troubleshoot';
import Manuals from './pages/SpaControl/ManualsWarranty/Manuals';
import UsersPage from './pages/Users/UsersPage';
import UserDetailsPage from './pages/UserDetails/UserDetailsPage';
import DealershipsPage from './pages/Dealerships/DealershipsPage';
import SettingsPage from './pages/Settings/SettingsPage';
import ChangePassword from './pages/Settings/ChangePassword/ChangePassword';
import EditProfile from './pages/Settings/EditProfile/EditProfile';
import MySpas from './pages/MySpas/MySpas';
import SpaErrorsPage from './pages/SpaErrors/SpaErrorsPage';
import DealershipDetailsPage from './pages/DealershipDetails/DealershipDetailsPage';
import LogsPage from './pages/Logs/LogsPage';
import ManageFirmwaresPage from './pages/ManageFirmwares/ManageFirmwaresPage';
import NotFound from './pages/General/NotFound';
import SpaReport from './pages/SpaReport/SpaReport';
import PowerConsumptionPage from './pages/PowerConsumption/PowerConsumptionPage';
import UpgradeRequestsPage from './pages/UpgradeRequests/UpgradeRequestsPage';
import PageTitle from './components/common/PageTitle/PageTitle';
import CommandsPage from './pages/Commands/CommandsPage';
import MyApiKeysPage from './pages/MyApiKeys/MyApiKeysPage';
import ManageApiKeysPage from './pages/ManageApiKeys/ManageApiKeysPage';
import MigrationProgressPage from './pages/MigrationProgress/MigrationProgressPage';
import RolesPage from './pages/Roles/RolesPage';
import RoleDetailsPage from './pages/Roles/RoleDetails/RoleDetailsPage';
import PermissionsPage from './pages/Permissions/PermissionsPage';
import UserGroupsPage from './pages/UserGroups/UserGroupsPage';
import UserGroupDetailsPage from './pages/UserGroups/UserGroupDetails/UserGroupDetailsPage';
import CommentsPage from './pages/Comments/CommentsPage';
import NewsPage from './pages/News/NewsPage';
import PromosPage from './pages/Promos/PromosPage';
import NotificationsPage from './pages/Notifications/NotificationsPage';
import DealerPromosPage from './pages/DealerPromos/DealerPromosPage';
import SpasRoute from './components/Layout/SpasRoute';
import Sanitation from './pages/SpaControl/Sanitation/Sanitation';
import SpaCommandsPage from './pages/SpaCommands/SpaCommandsPage';
import PeakManagementPage from "./pages/SpaControl/PeakManagement/PeakManagementPage";
import SpaControlRoute from './components/Layout/SpaControlRoute';
import AuthRoute from './components/Layout/AuthRoute';
import PermissionRoute from './components/Layout/PermissionRoute';
import RoleRoute from './components/Layout/RoleRoute';

const isColdTubBrand = () => {
  const brand = localStorage.getItem('data-brand');
  if (brand) return brand === 'coldtub';
  return window.location.hostname.includes('mycoldtub');
};

const AppRoutes: React.FC = () => {
  const base_title = isColdTubBrand() ? "My COLDTUB™" : "My Arctic Spas";
  return (
    <Router>
          <Routes>
            {/* Public routes */}
            <Route path="/" element={<AuthRoute><PageTitle title={"Login | "+base_title}/><LoginPage/></AuthRoute>}/>

            {/* Public routes - accessible without authentication */}
            <Route path="/login" element={<AuthRoute><PageTitle title={"Login | "+base_title}/><LoginPage/></AuthRoute>}/>
            <Route path="/register" element={<AuthRoute><PageTitle title={"Register | "+base_title}/><RegistrationPage/></AuthRoute>}/>
            <Route path="/forgot-password" element={<AuthRoute><PageTitle title={"Forgot Password | "+base_title}/><ForgotPasswordPage/></AuthRoute>}/>
            <Route path="/reset-password" element={<AuthRoute><PageTitle title={"Reset Password | "+base_title}/><ResetPasswordPage /></AuthRoute>}/>
            <Route path="/app-privacy" element={<><PageTitle title={"Privacy Policy | "+base_title}/><PrivacyPolicyPage/></>}/>
            <Route path="/delete-account" element={<><PageTitle title={"Delete Account | "+base_title}/><AccountDeletionPage/></>}/>
            <Route path="/security" element={<><PageTitle title={"Security | "+base_title}/><SecurityPolicyPage/></>}/>

            {/*  Customer Routes */}
                <Route
                    path="/my-spas"
                    element={
                        <SpasRoute>
                            <PageTitle title={"My Spas | "+base_title}/>
                            <MySpas/>
                        </SpasRoute>
                    }
                />

            {/* Spa Controls Routes */}
            <Route
                    path="/spa-control/:id"
                    element={
                        <SpaControlRoute>
                            <PageTitle title={"Spa Control | "+base_title}/>
                            <SpaControlPage/>
                        </SpaControlRoute>
                    }
                />

                <Route
                    path="/spa-control/:id/spaboy"
                    element={
                        <ProtectedRoute>
                            <PageTitle title={(isColdTubBrand() ? "COLDTUB™ Pal | " : "SpaBoy | ")+base_title}/>
                            <SpaBoy/>
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="/spa-control/:id/coldtub-pal"
                    element={
                        <ProtectedRoute>
                            <PageTitle title={"COLDTUB™ Pal | "+base_title}/>
                            <SpaBoy/>
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="/spa-control/:id/filtration"
                    element={
                        <ProtectedRoute>
                            <PageTitle title={"Filtration | "+base_title}/>
                            <Filtration/>
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="/spa-control/:id/sanitation"
                    element={
                        <ProtectedRoute>
                            <PageTitle title={"Sanitation | "+base_title}/>
                            <Sanitation/>
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="/spa-control/:id/peak-management"
                    element={
                        <ProtectedRoute>
                            <PageTitle title={"Peak Management | "+base_title}/>
                            <PeakManagementPage/>
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="/spa-control/:id/troubleshoot"
                    element={
                        <ProtectedRoute>
                            <PageTitle title={"Troubleshoot | "+base_title}/>
                            <Troubleshoot/>
                        </ProtectedRoute>
                    }
                />
                
                <Route
                    path="/spa-control/manuals-warranty"
                    element={
                        <ProtectedRoute>
                            <PageTitle title={"Manuals&Warranty | "+base_title}/>
                            <Manuals/>
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="/spa-control/contact-us"
                    element={
                        <ProtectedRoute>
                            <PageTitle title={"Contact Us | "+base_title}/>
                            <ContactUs/>
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="/settings"
                    element={
                        <ProtectedRoute>
                            <PageTitle title={"Settings | "+base_title}/>
                            <SettingsPage/>
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="/settings/edit-profile"
                    element={
                        <ProtectedRoute>
                            <PageTitle title={"Edit Profile | "+base_title}/>
                            <EditProfile/>
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="/settings/change-password"
                    element={
                        <ProtectedRoute>
                            <PageTitle title={"Change Password | "+base_title}/>
                            <ChangePassword/>
                        </ProtectedRoute>
                    }
                />

                {/* Units are now set on the Settings page; keep old links working */}
                <Route
                    path="/settings/unit-preference"
                    element={<Navigate to="/settings" replace/>}
                />

            {/* Admins Only Routes */}
                <Route
                    path="/home"
                    element={
                        <PermissionRoute permissions={['view_dashboard']}>
                            <PageTitle title={"Home | "+base_title}/>
                            <HomePage/>
                        </PermissionRoute>
                    }
                />
                <Route
                    path="/spas"
                    element={
                        <PermissionRoute permissions={['view_spas']}>
                            <PageTitle title={"Spas | "+base_title}/>
                            <SpasPage/>
                        </PermissionRoute>
                    }
                />

                <Route
                    path="/spa/:id"
                    element={
                        <PermissionRoute permissions={['view_spa_details']}>
                            <PageTitle title={"Spa Details | "+base_title}/>
                            <SpaDetailsPage/>
                        </PermissionRoute>
                    }
                />

                <Route
                    path="/spa/:id/errors"
                    element={
                        <PermissionRoute permissions={['view_spa_errors']}>
                            <PageTitle title={"Errors | "+base_title}/>
                            <SpaErrorsPage/>
                        </PermissionRoute>
                    }
                />

                <Route
                    path="/spa/:id/report"
                    element={
                        <PermissionRoute permissions={['view_spa_report']}>
                            <PageTitle title={"Report | "+base_title}/>
                            <SpaReport/>
                        </PermissionRoute>
                    }
                />

                <Route
                    path="/spa/:id/power-consumption"
                    element={
                        <ProtectedRoute>
                            <PageTitle title={"Power Consumption | "+base_title}/>
                            <PowerConsumptionPage/>
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="/firmware"
                    element={
                        <PermissionRoute permissions={['view_any_firmware']}>
                            <PageTitle title={"Firmware | "+base_title}/>
                            <ManageFirmwaresPage/>
                        </PermissionRoute>
                    }
                />

                <Route
                    path="/logs"
                    element={
                        <PermissionRoute permissions={['view_log_requests']}>
                            <PageTitle title={"Logs | "+base_title}/>
                            <LogsPage/>
                        </PermissionRoute>
                    }
                />

                <Route
                    path="/upgrade-requests"
                    element={
                        <PermissionRoute permissions={['view_upgrade_requests']}>
                            <PageTitle title={"Upgrade History | "+base_title}/>
                            <UpgradeRequestsPage/>
                        </PermissionRoute>
                    }
                />

                <Route
                    path="/users"
                    element={
                        <PermissionRoute permissions={['view_users']}>
                            <PageTitle title={"Users | "+base_title}/>
                            <UsersPage/>
                        </PermissionRoute>
                    }
                />

                <Route
                    path="/user/:id"
                    element={
                        <PermissionRoute permissions={['view_user_details']}>
                            <PageTitle title={"User Details | "+base_title}/>
                            <UserDetailsPage/>
                        </PermissionRoute>
                    }
                />

                <Route
                    path="/dealerships"
                    element={
                        <PermissionRoute permissions={['view_dealerships']}>
                            <PageTitle title={"Dealerships | "+base_title}/>
                            <DealershipsPage/>
                        </PermissionRoute>
                    }
                />

                <Route
                    path="/dealership/:id"
                    element={
                        <PermissionRoute permissions={['view_dealership']}>
                            <PageTitle title={"Dealership Details | "+base_title}/>
                            <DealershipDetailsPage/>
                        </PermissionRoute>
                    }
                />

                <Route
                    path="/api-commands"
                    element={
                        <PermissionRoute permissions={['view_api_commands']}>
                            <PageTitle title={"API Commands | "+base_title}/>
                            <CommandsPage/>
                        </PermissionRoute>
                    }
                />

                <Route
                    path="/my-api-keys"
                    element={
                        <PermissionRoute permissions={['manage_spa_api_keys','manage_all_api_keys']}>
                            <PageTitle title={"My API Keys | "+base_title}/>
                            <MyApiKeysPage/>
                        </PermissionRoute>
                    }
                />

                <Route
                    path="/manage-api-keys"
                    element={
                        <PermissionRoute permissions={['manage_all_api_keys']}>
                            <PageTitle title={"Manage API Keys | "+base_title}/>
                            <ManageApiKeysPage/>
                        </PermissionRoute>
                    }
                />

                <Route
                    path="/migration-progress"
                    element={
                        <RoleRoute roles={['admin','developer']}>
                            <PageTitle title={"Migration Progress | "+base_title}/>
                            <MigrationProgressPage/>
                        </RoleRoute>
                    }
                />


                <Route
                    path="/spa-commands"
                    element={
                        <PermissionRoute permissions={['view_spa_commands']}>
                            <PageTitle title={"Spa Commands | "+base_title}/>
                            <SpaCommandsPage/>
                        </PermissionRoute>
                    }
                />

                <Route
                    path="/roles"
                    element={
                        <PermissionRoute permissions={['view_roles']}>
                            <PageTitle title={"Roles | "+base_title}/>
                            <RolesPage/>
                        </PermissionRoute>
                    }
                />

                <Route
                    path="/roles/:id"
                    element={
                        <PermissionRoute permissions={['view_role_details']}>
                            <PageTitle title={"Role Details | "+base_title}/>
                            <RoleDetailsPage/>
                        </PermissionRoute>
                    }
                />

                <Route
                    path="/permissions"
                    element={
                        <PermissionRoute permissions={['view_permissions']}>
                            <PageTitle title={"Permissions | "+base_title}/>
                            <PermissionsPage/>
                        </PermissionRoute>
                    }
                />


                
                <Route
                    path="/user-groups"
                    element={
                        <PermissionRoute permissions={['view_user_groups']}>
                            <PageTitle title={"User Groups | "+base_title}/>
                            <UserGroupsPage/>
                        </PermissionRoute>
                    }
                />

                <Route
                    path="/user-groups/:id"
                    element={
                        <PermissionRoute permissions={['view_user_group_details']}>
                            <PageTitle title={"User Group Details | "+base_title}/>
                            <UserGroupDetailsPage/>
                        </PermissionRoute>
                    }
                />

                
                <Route
                    path="/spa/:id/comments"
                    element={
                        <PermissionRoute permissions={['view_spa_comments']}>
                            <PageTitle title={"Comments | "+base_title}/>
                            <CommentsPage/>
                        </PermissionRoute>
                    }
                />

                <Route
                    path="/comments"
                    element={
                        <PermissionRoute permissions={['view_all_comments']}>
                            <PageTitle title={"Comments | "+base_title}/>
                            <CommentsPage/>
                        </PermissionRoute>
                    }
                />

                <Route
                    path="/news"
                    element={
                        <ProtectedRoute>
                            <PageTitle title={"News | "+base_title}/>
                            <NewsPage/>
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="/dealer-promos"
                    element={
                        <PermissionRoute permissions={['can_send_promos', 'can_send_promos_to_all', 'can_send_notifications', 'can_send_notifications_to_all']}>
                            <PageTitle title={"Dealer Promos | "+base_title}/>
                            <DealerPromosPage/>
                        </PermissionRoute>
                    }
                />

                <Route
                    path="/promos"
                    element={
                        <PermissionRoute permissions={['can_send_promos', 'can_send_promos_to_all']}>
                            <PageTitle title={"Promos | "+base_title}/>
                            <PromosPage/>
                        </PermissionRoute>
                    }
                />

                <Route
                    path="/notifications"
                    element={
                        <PermissionRoute permissions={['can_send_notifications', 'can_send_notifications_to_all']}>
                            <PageTitle title={"Notifications | "+base_title}/>
                            <NotificationsPage/>
                        </PermissionRoute>
                    }
                />

            <Route
                path='*'
                element={
                    <>
                    <PageTitle title={"404 Not Found | "+base_title}/>
                    <NotFound/>
                    </>
                } 
            />
        </Routes>
    </Router>
  );
};

export default AppRoutes;